import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'Device'
const DB_VERSION = 1
const STORE_NAME = 'Devices'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: '_id' }
])

const initDbDevices = () => {
    return dbInstance.init()
}

const agregar = async (data) => {
    // Original calls initDbDevices internally. We can just use the instance.
    // The GenericDatabase add method will handle getting the DB instance.
    return dbInstance.add(STORE_NAME, data)
}

const obtener = async (clave) => {
    // Original calls initDbDevices internally.
    return dbInstance.get(STORE_NAME, clave)
}

const actualizar = async (data) => {
    // Original calls initDbDevices internally.
    return dbInstance.put(STORE_NAME, data)
}

const eliminar = async (clave) => {
    // Original calls initDbDevices internally.
    return dbInstance.delete(STORE_NAME, clave)
}

const removerTodo = async (databaseName) => {
    // Original explicitly takes databaseName. Our GenericDatabase instance
    // already knows its own name. If the intent was to delete ANY DB, it's different.
    // Assuming it's to delete *this* database.
    return dbInstance.deleteDatabase()
}

const consultar = async () => {
    // Original calls initDbDevices internally.
    return dbInstance.getAll(STORE_NAME)
}

export default {
    initDbDevices,
    agregar,
    obtener,
    actualizar,
    eliminar,
    removerTodo,
    consultar
}
